import React, { useState, useEffect, useRef } from "react";
import ChatSessionService from "services/chat-session.service";
import AuthService from "services/auth.service";
import IconQuestionnaire from "assets/icons/AssessmentIcon.svg";
import IconArrowDown from "assets/icons/expandAllIcon.svg";
import { Accordion, Card, Button } from "react-bootstrap";
import Spinner from "react-bootstrap/Spinner";

function AccordianNutritionQuestionnaire({ chat }) {
  const isCancelled = useRef(false);
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getNutritionQuestionnaire();
    return () => {
      isCancelled.current = true;
    };
  }, []); // eslint-disable-line

  const getNutritionQuestionnaire = () => {
    setLoading(true);
    ChatSessionService.getNutritionQuestionnaire(chat.id)
      .then(
        (res) => {
          if (isCancelled.current) return;
          const list = Array.isArray(res) ? res : (res?.questionnaires ?? []);
          setQuestions(list);
        },
        (error) => {
          if (error?.response?.status === 401) {
            AuthService.logout();
            window.location.replace("/eb/login");
          }
        },
      )
      .finally(() => {
        if (!isCancelled.current) setLoading(false);
      });
  };

  const renderBody = () => {
    if (loading) {
      return (
        <div className="loader">
          <Spinner animation="border" className="spinner" />
        </div>
      );
    }

    if (questions.length === 0) {
      return <div className="no-result text-center">No data available</div>;
    }

    return questions.map((item, i) => (
      <div className="info-row" key={`nutrition-questionnaire-${i}`}>
        <div className="label">{item.question}</div>
        <div className="info">{item.answer || "-"}</div>
      </div>
    ));
  };

  return (
    <Card className="nutrition-questionnaire-info card-accordian">
      <Card.Header>
        <Accordion.Toggle as={Button} variant="link" eventKey="5">
          <div className="header-title">
            <img
              src={IconQuestionnaire}
              alt="icon-questionnaire"
              className="title-icon"
            />
            <div className="title">Nutrition Questionnaire</div>
          </div>
          <div>
            <img src={IconArrowDown} alt="icon-arrow-down" />
          </div>
        </Accordion.Toggle>
      </Card.Header>
      <Accordion.Collapse eventKey="5">
        <Card.Body>{renderBody()}</Card.Body>
      </Accordion.Collapse>
    </Card>
  );
}

export default AccordianNutritionQuestionnaire;
